import CartAddButton from '../CartAddButton/CartAddButton';
import { useCartButtonRowStyles } from './CartButtonRow.styles';
import { useCart } from '../../../../contexts/CartContext/CartContext.hooks';
import { useState } from 'react';
import MaxItemPopup from '../../../../components/popups/MaxItemPopup/MaxItemPopup';
import { useLineEdit } from '../../../../contexts/LineEditContext/LineEditContext.hooks';

const CartButtonRow = () => {
    const { cart } = useCart();
    const styles = useCartButtonRowStyles();

    const [maxItemPopup, setMaxItemPopup] = useState(false);

    const { setLines, setCurrent } = useLineEdit();

    const addLine = () => {
        if (cart.lineItems.length >= 5) {
            setMaxItemPopup(true);
            return;
        }

        const lineItems = cart.lineItems;
        const current = cart.lineItems.length;

        lineItems.push({
            isPrimaryLine: current === 0,
            phoneNumberInformation: { needsNewNumber: false },
            lineNumber: current
        });

        setLines(lineItems);
        setCurrent(current);
    };

    const addAccessories = () => {
        window.location.href = '/Accessories';
    };

    return (
        <div className={styles.root}>
            <CartAddButton text='Add Line' onClick={addLine} />

            <CartAddButton text='Add Accessories' onClick={addAccessories} />

            <MaxItemPopup
                showPopup={maxItemPopup}
                setPopup={setMaxItemPopup}
                popupHeader={
                    'To add more than 5 phone lines, please chat with us or visit our store.'
                }
            />
        </div>
    );
};

export default CartButtonRow;
